<div class="modal-header header">
  <h5 class="modal-title w-100" [translate]="Localization.NewCustomCheckpoint"></h5>
  <button type="button" class="close pull-right modal-close" aria-label="Close" (click)="close()">
    <span aria-hidden="true">×</span>
  </button>
</div>
<div class="modal-body pt-0 lite-modal m-2">
    <div class="d-flex justify-content-between align-items-center mt-2">
        <div class="d-flex">
            <img src="assets/images/checklists/checklist.svg" class="mr-1 logo" width="25" height="30">
            <h3>{{Localization.Checkpoint | translate}}</h3>
        </div>
        <chapps-icon-label [icon]="'fa-info-circle'"
            [tooltip]="Localization.AddCheckpointTooltip"
            [tooltipPlacement]="'right'">
        </chapps-icon-label>
    </div>
    <form *ngIf="formGroup" [formGroup]="formGroup">
        <div class="mt-2">
            <chapps-text-input
                [placeholder]="Localization.Label | translate"
                [control]="labelTypeControl">
            </chapps-text-input>
        </div>
        <div class="mt-4">
            <chapps-select-input
                [items]="valueTypes"
                [placeholder]="Localization.CheckPointValueType | translate"
                [control]="valueTypeControl">
            </chapps-select-input>
        </div>
        <div class="mt-4">
            <chapps-select-input
                [items]="categories"
                [placeholder]="Localization.KindOfProblem | translate"
                [control]="categoryTypeControl">
            </chapps-select-input>
        </div>
    </form>
</div>
<div class="modal-footer justify-content-end">
  <chapps-secondary-button
    [loading]="isCreatingInProgress"
    [label]="Localization.Save"
    [small]="true"
    (clicked)="onSubmit()">
  </chapps-secondary-button>
</div>
